import React, { Fragment } from "react";
import "./load.css";

const Loading = () => {
  return (
    <Fragment>
      <div id="spinner" className="containers">
        <span className="loader"></span>
      </div>
    </Fragment>
  );
};

export default Loading;
